import ArrowBtn from "../../../components/arrowbtn/ArrowBtn";
import { baseUrl } from "../../../utils/apiData";
import "./HomeBiGridInfo.scss";

const HomeBiGridInfo = ({
  title,
  onClick,
  para,
  order,
  classList,
  img,
  btn,
}) => {
  return (
    <section className={`home_bigrid_info ${classList}`}>
      <div className="content_wrap p_bottom">
        <div className="left">
          <h2 className="wow fadeInUp">{title}</h2>
          <p className="wow fadeInUp" data-wow-delay="0.15s">
            {para}
          </p>
          {btn && (
            <ArrowBtn
              text={btn}
              handleClick={onClick}
              theme="secondary_ternery"
            />
          )}
        </div>
        <div className="right" style={{ order: `${order}` }}>
          <img src={`${baseUrl}/${img}`} alt="Farsight" />
        </div>
      </div>
    </section>
  );
};

export default HomeBiGridInfo;
